// Pain subsection form field enum
export enum PainFormField {
  PAIN_STATUS = 'medicalBackground/pain/status',
  PAIN_GOAL = 'medicalBackground/pain/goal',
  PAIN_FLACC_SCALE_FACE = 'medicalBackground/pain/flaccScaleFace',
  PAIN_FLACC_SCALE_LEGS = 'medicalBackground/pain/flaccScaleLegs',
  PAIN_FLACC_SCALE_ACTIVITY = 'medicalBackground/pain/flaccScaleActivity',
  PAIN_FLACC_SCALE_CRY = 'medicalBackground/pain/flaccScaleCry',
  PAIN_FLACC_SCALE_CONSOLABILITY = 'medicalBackground/pain/flaccScaleConsolability',
  PAIN_SYSTEM_SUMMARY = 'medicalBackground/pain/systemSummary'
}
